module.exports = __webpack_public_path__ + "media/images/cms/img_slide_17-29af91bba3bf4e3dbca28dfcd4e3e1cb.jpg";